export const csConstants = {
  INVALID_FILE_SELECTED: "CS_INVALID_FILE_SELECTED",
  VALIDATE_REQUEST: "CS_VALIDATE_REQUEST",
  VALIDATE_SUCCESS: "CS_VALIDATE_SUCCESS",
  VALIDATE_FAILURE: "CS_VALIDATE_FAILURE",
  VALIDATION_STATUS_REQUEST: "CS_VALIDATION_STATUS_REQUEST",
  VALIDATION_STATUS_SUCCESS: "CS_VALIDATION_STATUS_SUCCESS",
  VALIDATION_STATUS_FAILURE: "CS_VALIDATION_STATUS_FAILURE",
  CREATE_ORDER_REQUEST: "CS_CREATE_ORDER_REQUEST",
  CREATE_ORDER_SUCCESS: "CS_CREATE_ORDER_SUCCESS",
  CREATE_ORDER_FAILURE: "CS_CREATE_ORDER_FAILURE",
  SET_EMAIL_REQUEST: "CS_SET_EMAIL_REQUEST",
  SET_EMAIL_SUCCESS: "CS_SET_EMAIL_SUCCESS",
  SET_EMAIL_FAILURE: "CS_SET_EMAIL_FAILURE",
  UNSET_EMAIL: "CS_UNSET_EMAIL",
  GET_BUNDLES_REQUEST: "CS_GET_BUNDLES_REQUEST",
  GET_BUNDLES_SUCCESS: "CS_GET_BUNDLES_SUCCESS",
  GET_BUNDLES_FAILURE: "CS_GET_BUNDLES_FAILURE",
  SET_BUNDLE_REQUEST: "CS_SET_BUNDLE_REQUEST",
  SET_BUNDLE_SUCCESS: "CS_SET_BUNDLE_SUCCESS",
  SET_BUNDLE_FAILURE: "CS_SET_BUNDLE_FAILURE",
  CHARGE_CARD_REQUEST: "CS_CHARGE_CARD_REQUEST",
  CHARGE_CARD_SUCCESS: "CS_CHARGE_CARD_SUCCESS",
  CHARGE_CARD_FAILURE: "CS_CHARGE_CARD_FAILURE",
  CLAIM_THINKIFIC_DISCOUNT_CODE_REQUEST: "CS_CLAIM_THINKIFIC_DISCOUNT_CODE_REQUEST",
  CLAIM_THINKIFIC_DISCOUNT_CODE_SUCCESS: "CS_CLAIM_THINKIFIC_DISCOUNT_CODE_SUCCESS",
  CLAIM_THINKIFIC_DISCOUNT_CODE_FAILURE: "CS_CLAIM_THINKIFIC_DISCOUNT_CODE_FAILURE",
};